import axios from "axios"
import { baseURL, config, requestID } from "../../../common/utils"

export const transferStocks = async (data) => {

    const payload = {
        requestID: requestID(),
        payload: data
    }

    try {
        const res = axios.post(`${baseURL}warehouses/transferStock`, payload, config)
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}




export const getTotalStockPerProduct = async () => {

    const payload = {
        requestID: requestID(),
    }

    try {
        const res = axios.post(`${baseURL}warehouses/getTotalStockPerProduct`, payload, config)
        console.log(res)
        return res
    } catch (error) {

        return error
    }
}

export const getStocksTransfer = async () => {

    const payload = {
        requestID: requestID(),
    }

    try {
        const res = axios.post(`${baseURL}warehouses/getStocksTransfer`, payload, config)
        console.log(res)
        return res
    } catch (error) {

        return error
    }
}



export const addBarRequest_production = async (data) => {

    const payload = {
        requestID: requestID(),
        data: data
    }
    try {
        const res = axios.post(`${baseURL}warehouses/addBarRequest_production`, payload, config)

        console.log(res)

        return res
    } catch (error) {

        return error
    }
}
export const addBranchRequest = async (data) => {

    const payload = {
        requestID: requestID(),
        data: data
    }
    try {
        const res = axios.post(`${baseURL}warehouses/addBarRequest`, payload, config)

        console.log(res)

        return res
    } catch (error) {

        return error
    }
}
export const getMyBranchesRequestsWithItems = async () => {

    const payload = {
        requestID: requestID(),
    }
    try {
        const res = axios.post(`${baseURL}warehouses/getMyBarRequestsWithItems`, payload, config)
        console.log('resssss', res)
        return res
    } catch (error) {

        return error
    }
}

export const getPendingBarRequestsWithItems = async () => {

    const payload = {
        requestID: requestID(),
    }
    try {
        const res = axios.post(`${baseURL}warehouses/getPendingBarRequestsWithItems`, payload, config)
        return res
    } catch (error) {

        return error
    }
}

export const getAllBranchesRequestsWithItems = async () => {

    const payload = {
        requestID: requestID(),
    }
    try {
        const res = axios.post(`${baseURL}warehouses/getAllBarRequestsWithItems`, payload, config)
        console.log('resssss', res)
        return res
    } catch (error) {

        return error
    }
}



export const approveBarRequest = async (data) => {

    const payload = {
        requestID: requestID(),
        data: data
    }
    try {
        const res = axios.post(`${baseURL}warehouses/approveBarRequest`, payload, config)
        
        return res
    } catch (error) {

        return error
    }
}